import { leagueService } from '@/services';
import { useLeagueStore } from '@/stores/league';

export function useLeagueFavorite() {
    function isLeagueProcessing(leagueId: number): boolean {
        const store = useLeagueStore();
        return leagueId in store.favoriteLeagueProcessing;
    }

    function isLeagueFavorite(leagueId: number): boolean {
        const store = useLeagueStore();
        return leagueId in store.favoriteLeague;
    }

    function toggleLeagueFavorite(leagueId: number): void {
        if (isLeagueProcessing(leagueId)) {
            return;
        }

        if (isLeagueFavorite(leagueId)) {
            void leagueService.removeFavorite(leagueId);
        } else {
            void leagueService.addFavorite(leagueId);
        }
    }

    return {
        isLeagueProcessing,
        isLeagueFavorite,
        toggleLeagueFavorite,
    };
}
